
import { Component, Vue, Prop } from "vue-property-decorator";
import { Answer } from "@/lib/model/exam/result"; //候选人答案内容
import { Question, ChoiceQuestion } from "@/lib/model/question/question";
import { getDimensionColor } from "@/lib/dimension/dimension-color";
import TooltipMaterials from "@/components/tooltip/index.vue";
@Component({
  components: {
    TooltipMaterials
  }
})
export default class QuestionContent extends Vue {
  @Prop({ type: Question, required: true }) question!: Question; //题目
  @Prop({ type: Boolean, required: true }) canSelectFlag!: boolean; //是否可选
  @Prop({ type: Boolean, required: false, default: false }) checked!: boolean; //是否选中
  @Prop({ type: Boolean, required: false, default: false }) mark!: boolean; //是否阅卷页面、
  @Prop({ type: Answer, default: new Answer() }) answer!: Answer; //候选人回答
  @Prop({ type: Number, default: "" }) qIndex!: number;
  @Prop({ type: Boolean, default: true }) showChange!: boolean; //是否展示题干变量
  @Prop({ type: Boolean, default: false }) isFSK!: boolean; //富士康
  @Prop({ type: Boolean, default: false }) marked!: boolean; //是否阅过卷  用来判是否可修改试卷
  @Prop({ type: Boolean, default: false }) isNewAi!: boolean; //是否Aibuilder阅卷

  // checkedFlag = false;
  noAnswer = "未作答";
  lastDesc = ""; //题干变量最后一节
  audioElement: any = null;
  mounted() {
    // this.checkedFlag = this.checked;
    this.listenVideo();
  }
  get getScoreRule() {
    const s = this.question.scoreRuleStatus;
    return s === 10
      ? "AI"
      : s === 20
      ? "自动"
      : s === 30
      ? "人工"
      : "无评分规则";
  }

  //根据类型 获取对应值
  getQuestionType(): string[] {
    switch (this.question.type) {
      case 1:
        return ["单选题", ""];
      case 2:
        return ["多选题", ""];
      case 5:
        return ["填空题", ""];
      case 6:
        return ["视频问答题", ""];
      case 7:
        return ["测评单选题", ""];
      case 8:
        return ["音频题", ""];
      case 101:
        return ["通勤时间题", ""];
      case 102:
        return ["色盲检测", ""];
      default:
        return ["其他类型", ""];
    }
  }
  playAudioDesc() {
    // 先停止其他音频
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audioElement: any) => {
      // 暂停其他audio用于后面判断当前audio的播放状态
      if (audioElement.id !== "audioDesc-" + this.question.questionId) {
        // 切换audio需要从头播放时放开下面
        // audioElement.setAttribute('src', audioElement.src)
        audioElement.pause();
      }
    });
    // 播放音频材料
    if (!this.audioElement) {
      this.audioElement = document.createElement("audio");
      document.body.appendChild(this.audioElement);
    }
    if (!this.audioElement.paused) {
      this.audioElement.pause();
    } else {
      // 需求暂停后不要从头播放，需要时去掉判断条件
      if (!this.audioElement.id && !this.audioElement.src) {
        this.audioElement.setAttribute(
          "id",
          "audioDesc-" + this.question.questionId
        );
        this.audioElement.setAttribute("src", this.question.audioDescUrl);
      }
      this.audioElement.play();
    }
  }
  //填空题规则
  getRule(i: any, questionRule: any) {
    switch (i) {
      case 0:
        return questionRule.strictOrder == 1 ? "完全一致" : "顺序可不一致";
      case 1:
        return questionRule.scoreType == 1
          ? "出错得0分，全对得满分"
          : questionRule.scoreType == 2
          ? "按答对比例给分"
          : "各空分数独立设置";
      case 2:
        return questionRule.ignoreBlank == 1
          ? "忽略答案中的空格"
          : "不忽略答案中的空格";
    }
  }
  //asr时间格式化
  formatSeconds(mss: number) {
    const hours =
      Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) < 10
        ? "0" + Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        : Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    const minutes =
      Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60)) < 10
        ? "0" + Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60))
        : Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60));

    const seconds =
      (mss % (1000 * 60)) / 1000 < 10
        ? "0" + Math.floor((mss % (1000 * 60)) / 1000)
        : Math.floor((mss % (1000 * 60)) / 1000);

    return `${hours}:${minutes}:${seconds}`;
  }
  //选择播放语句
  selectVideoTime(st: any, id: any) {
    // @ts-ignore
    const player: HTMLMediaElement = document.getElementById("player" + id);
    player.currentTime = Math.floor(st / 1000);
    player.play();
  }
  //拼接通勤参考答案
  getLocationAnswer(q: Question) {
    const option1 = q.locationQuestionConfig.choiceQuestionList;
    const option2 = q.locationQuestionConfig.timeToScoreRules;
    let t =
      q.locationQuestionConfig.useDrivingTime === 1
        ? `驾车时：`
        : `乘坐公共交通时：`;
    option2.forEach((d: any, i: number) => {
      if (i === option2.length - 1) {
        t += `${d.timeRange[0]}分钟以上（${d.score}分）；<br/>`;
        return;
      }
      t += `${d.timeRange[0]}-${d.timeRange[1]}分钟（${d.score}分）；`;
    });
    option1.forEach((d: any, i: number) => {
      t += `<span class="p-inline">${d.desc}</span>（${d.score}分）<br/>`;
    });

    return t;
  }
  //拼接通勤时间 候选人回答
  getLocationText() {
    const t = this.answer?.locationQuestionAnswer;
    //未作答
    if (!t) return;
    //正常作答
    if (this.answer?.keys?.[0]) {
      return `我住在<b>${
        t.locationName
      }</b>附近，<br/>经系统计算从该地点到上班地点：<br/>驾车距离<b>${(
        t.distanceDriving / 1000
      ).toFixed(1)}公里</b>，用时<b>${
        t.timeDriving
      }分钟</b>，<br/>乘坐公共交通距离<b>${(t.distanceTransit / 1000).toFixed(
        1
      )}公里</b>，用时<b>${t.timeTransit}分钟</b>。`;
    } else {
      //定位故障
      if (t.locationName) {
        return `我住在${t.locationName}附近`;
      }
      //暂无居所
      if (t.choiceQuestionAnswer) {
        const res: ChoiceQuestion[] = this.question.locationQuestionConfig.choiceQuestionList.filter(
          (d: any) => {
            return d.key === t.choiceQuestionAnswer;
          }
        );
        return res?.[0]?.desc;
      }
    }
  }
  //选中card复选框
  checkCard() {
    // this.checked = !this.checked;
  }
  //题目tag选中
  changeTag(item: any) {
    item.hrResult = item.hrResult === 0 ? 1 : 0;
    //插入文本
    if (item.hrResult === 1) {
      this.$emit("resultAddText", item.tagName);
    }
  }
  //监听video播放
  listenVideo() {
    const v: any = this.$refs.video;
    if (!v) return;
    v.addEventListener("play", () => {
      this.$emit(
        "pauseOther",
        this.answer.aliyunVideoId,
        this.question.questionId
      );
    });
  }
  //自动暂停
  pauseMe(id: string) {
    // @ts-ignore
    const player: HTMLMediaElement = document.getElementById(
      "player" + this.answer.aliyunVideoId
    );
    if (this.answer.aliyunVideoId !== id) {
      player?.pause();
    }
  }
  //正确选项
  getRightAnswer(list: any) {
    return list.find((d: any) => {
      return d.isRight === 1;
    }).key;
  }
  //题干变量处理
  filterQuestion(q: Question) {
    const result: any[] = [];
    let indexStart = 3;
    q.descTemplateConfig.forEach((d: any, i: number) => {
      const end = q.desc.indexOf(d.originStr);
      // if(end === -1) return
      const ob: any = {};
      ob.text = q.desc.slice(indexStart, end);
      ob.str = d.originStr;
      let st = `<span style="
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #111111;
        line-height: 24px;"><span style="color:#525FFFFF;font-weight: 600;font-family:   PingFang SC">#${d.originStr}# </span>是一个变量<br>候选人看到的内容取决于其在${d.keyType}填写的<span style="font-family:   PingFang SC;font-weight: 600;"> ${d.paramName}</span></span>
        <div style="width: 100%;
        padding:1px 0;
        margin-top:12px;
        background: #F4F7FC;
        border-radius: 8px;">`;
      d.replaceStrList.forEach((m: any, n: number) => {
        st += `<div style="
                  display:flex;
                  align-items:baseline;
                  margin:8px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #111111;
                  line-height: 24px;">
                  <span style="display: inline-block;
                   flex-shrink:0;
                   flex-grow:0;
                   position:relative;
                   top:-2px;
                   width: 4px;
                   height: 4px;
                   border-radius: 6px;
                   border: 1px solid #111111;
                   margin: 0 6px 0 0;"></span><span><span style="font-family:   PingFang SC;font-weight: 600;"> ${d.paramName} </span>为<span style="font-family:   PingFang SC;font-weight: 600;"> ${m.key} </span>时，此处展示为<span style="font-family:   PingFang SC;font-weight: 600;"> ${m.value}</span>;</span></div>`;
      });
      st += `<div style="
                  margin:8px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #111111;
                  line-height: 24px;">
                  <span style="display: inline-block;
                   width: 4px;
                   height: 4px;
                   border-radius: 6px;
                   border: 1px solid #111111;
                   margin: 0 6px 2px 0;"></span>除以上情况外，此处展示为<span style="font-family:   PingFang SC;font-weight: 600;"> ${d.defaultStr}。</span></div></div>`;
      ob.options = st;
      result.push(ob);
      indexStart = end + d.originStr.length;
    });
    this.lastDesc = q.desc.slice(indexStart, -4);
    return result;
  }

  //维度标签颜色处理
  getDimColors(name: string) {
    return getDimensionColor(name);
  }
}
